import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import {useEdits} from "../../../contexts/edits";
import {useSetting} from "../../../contexts/setting";
import {useImages} from "../../../contexts/images";
import BgTransformer from "../../../layout/BgTransformer";
import adsAssets from "../../../data/ads-assets.json";

/**
 * EmailLargeAds — 650×325 email banner. Figma source: 1429:830.
 *
 * Same content + structure as BlogPostAds (gradient title + dark-gradient
 * bubble subtitle), at ~half scale. Group 2 union is flattened in Figma
 * (no separate Vector 1 child), so the tail SVG path is a SoMe-scaled
 * approximation rather than a verbatim Figma lift.
 */
const EmailLargeAds = ({id, zoom}) => {
  const {channel, product, type, bgOption, locked} = useSetting();
  const {customBgs} = useImages();
  const isLocked = locked.some((x) => x === id);
  const customBgUrl = (isLocked ? customBgs[id] : undefined) || customBgs.main || null;
  const {titles, subtitles} = useEdits();
  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;

  const bgIdx = bgOption || 1;
  const assetKey = `${channel.value}/${product.value}/${type.value}/${bgIdx}/${id}`;
  const bgUrl = adsAssets[assetKey]?.url;

  return (
    <div id={id} className={`template ${type.value} tpl-card`} style={{"--zoom-level": zoom}}>
      <div className="tpl-card__inner">
        {customBgUrl || bgUrl ? <BgTransformer src={customBgUrl || bgUrl} id={id} /> : null}
        <div className="tpl-bubble">
          <h2 className="subtitle">
            <Textarea id={id} text={subtitle} />
          </h2>
          {/* Tail path approximated from BlogPostAds's Figma Vector 1
           * (1429:815) scaled to fit this template's smaller bubble.
           * Group 2 (1429:835) is flattened in Figma, so no verbatim path
           * is available. Gradient is aligned to the bubble's coord frame
           * via userSpaceOnUse so it continues seamlessly across rect+tail. */}
          <svg
            className="tpl-bubble__tail"
            viewBox="0 0 25.43 29.08"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <defs>
              <linearGradient
                id="EmailLargeAds-tail-gradient"
                gradientUnits="userSpaceOnUse"
                x1="6.57"
                y1="-39.12"
                x2="245.91"
                y2="34.27"
              >
                <stop offset="0" stopColor="#211104" />
                <stop offset="1" stopColor="#472407" />
              </linearGradient>
            </defs>
            <path
              d="M0 28.88C0 28.88 6.57 11.37 6.57 0L25.43 13.66C16.06 24.66 0 28.88 0 28.88Z"
              fill="url(#EmailLargeAds-tail-gradient)"
            />
          </svg>
        </div>
        <h1 className="title">
          <Textarea id={id} text={title} />
        </h1>
      </div>
    </div>
  );
};

export default EmailLargeAds;
